import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.GET_ALL_PROTOCOLS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FILE_TRANSFER_PROTOCOL_LIST,
                    payload: {
                        protocolList: response.data
                    }
                }
            ];
        case handlers.GET_ALL_IN_FORMATS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FILE_TRANSFER_IN_FORMATS,
                    payload: {
                        inFormatList: response.data
                    }
                }
            ];
        case handlers.GET_ALL_OUT_FORMATS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FILE_TRANSFER_OUT_FORMATS,
                    payload: {
                        outFormatList: response.data
                    }
                }
            ];
        case handlers.TEST_PROTOCOL:
            if (response.result !== resultCodes.RESULT_OK) {
                if (Array.isArray(response.msgParams) && response.msgParams[1] !== undefined) {
                    return [
                        messageHelper.getInfoMessageAction("flashMessage.connectionFailed", [response.msgParams[1]])
                    ];
                }

                return [messageHelper.getInfoMessageAction("flashMessage.connectionFailed", [response.msg])];
            }

            if (response.data) {
                return [messageHelper.getSuccessMessageAction("flashMessage.connectionSuccess")];
            }

            return [messageHelper.getInfoMessageAction("flashMessage.connectionFailed", ["-/"])];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
